import {ImageRequestParams} from "../models/image/image-request-params";
import {IMAGE} from "../models/image/image.consts";

export class XRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `Website/AssetsSVGNewBrand/x`;
  }

  get defaultFormat(): String {
    return IMAGE.FORMAT.SVG;
  }
}
